<div class="container-component">

    <!-- Resume table -->
    <div class="leaderboard">
        <div class="header-top"> COPA YOMP! 2026 </div>        
        <div class="header-title"> TABLA DE GOLEADORES NACIONAL </div>
        <div class="score-table">
            <table>
                <thead>
                    <tr *ngIf="storeFirstPlace$ | async as storeFirstPlace">
                        <th class="centerColumns firstPlace">
                            <img class="icon lg"
                                src="/assets/icons/png/first-place.png"
                                alt="" />
                        </th>

                        <th class="firstPlace">
                            {{ storeFirstPlace.storeName | uppercase }}
                        </th>

                        <th class="centerColumns firstPlace">
                            {{ storeFirstPlace.totalGoals }}
                        </th>

                        <th class="centerColumns firstPlace">
                            {{ storeFirstPlace.businessUnitName | uppercase }}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let store of (storesWithoutFirstPlace$ | async)?.worldCupStandingGoals">
                        <td class="centerColumns" [ngClass]="store.cssClass">
                            {{ store.ranking }}
                        </td>
                        <td [ngClass]="store.cssClass">
                            {{ store.storeName }}
                        </td>
                        <td class="centerColumns" [ngClass]="store.cssClass">
                            {{ store.totalGoals }}
                        </td>
                        <td class="centerColumns" [ngClass]="store.cssClass">
                            {{ store.businessUnitName | uppercase }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <div class="soccer-ball"></div>

    <div class="disclaimer"> *Aplica solo en ciudades mundialistas </div>  
    
    <!-- Soccer field -->
    <div class="soccer-field" [formGroup]="frmElement">
        <!-- Input -->
        <input type="text" class="search-input" maxlength="6" placeholder="Coloca tu ID" formControlName="StoreId"/>
    </div>

    <!-- User table -->
    <table class="own-score-table">
        <thead>
            <tr>
                <th>Lugar</th>
                <th>Negocio</th>
                <th>Goles acumulados</th>
                <th>Ciudad</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngIf="(worldCupStandings$ | async)?.rankStoreGoals as storeFound">
                <td>{{ storeFound.ranking }}</td>
                <td>{{ storeFound.storeName }}</td>
                <td class="with-icon">
                    {{ storeFound.totalGoals }}
                    <img class="icon" src="/assets/background/png/soccer-ball.png" alt="" />
                </td>
                <td>{{ storeFound.businessUnitName | uppercase }}</td>
            </tr>
        </tbody>
    </table>
</div>